const getAppliedGiftcards = state => state.giftcard?.appliedGiftcards;

export default getAppliedGiftcards;
